export function centimos(valor) {
  const texto = String(valor == null ? '' : valor).trim().replace(',', '.');
  if (!/^\d{1,8}(\.\d{1,2})?$/.test(texto)) return null;
  const [euros, decimal = ''] = texto.split('.');
  return Number(euros) * 100 + Number(decimal.padEnd(2, '0'));
}

export function importeTexto(valor) {
  const absoluto = Math.abs(valor);
  return `${valor < 0 ? '-' : ''}${Math.floor(absoluto / 100)}.${String(absoluto % 100).padStart(2, '0')}`;
}

export function repartirCentimos(total, cantidad) {
  if (!Number.isSafeInteger(total) || total <= 0 || cantidad < 1 || total < cantidad) return [];
  const base = Math.floor(total / cantidad);
  const sobrantes = total % cantidad;
  return Array.from({ length: cantidad }, (_, i) => base + (i < sobrantes ? 1 : 0));
}

export function validarFilaAutorizacion(fila) {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(fila.email_destinatario || '').trim())) {
    return 'Indica un correo válido.';
  }
  const importe = centimos(fila.autorizacion_importecarga);
  const deposito = centimos(fila.autorizacion_importedeposito);
  if (importe === null || importe <= 0) return 'Indica un importe positivo con un máximo de dos decimales.';
  if (deposito === null) return 'Indica un depósito válido, que puede ser cero.';
  if (deposito > importe) return 'El depósito no puede superar el importe asignado.';
  return '';
}
